import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { CustomerLookup } from '../types/api';
import { useCustomersApi } from './use-customers-api';

type AddSkuToCartVars = { lookup: CustomerLookup; sku: string };

type UseAddSkuToCartOptions = Partial<
  Omit<UseMutationOptions<void, Error, AddSkuToCartVars>, 'mutationFn'>
>;

// Adds a SKU to a customer's cart. The cart lives server-side keyed to the customer, so there's
// no client cache to prime. `lookup` is a mutate variable because callers typically resolve the
// target customer asynchronously (e.g. after a create/search settles).
export function useAddSkuToCart(options: UseAddSkuToCartOptions = {}) {
  const { customersApi } = useCustomersApi();

  return useMutation<void, Error, AddSkuToCartVars>({
    ...options,
    mutationFn: ({ lookup, sku }) => customersApi.customer(lookup).addSkuToCart(sku),
  });
}
